/**
* DevExpress Dashboard (_object-data-source.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { filter } from '../../metadata/_base-metadata';
import { dataSourceSerializationsInfo } from './_data-source';
export let objectDataSourceSerializationsInfo = dataSourceSerializationsInfo.concat([filter]);
